import { Link } from "react-router-dom";
import logo from "layout/Footer/Logo/assets/logo.svg";

function Logo() {
  return (
    <Link to="/">
      <img src={ logo } alt="Trefpunt"/>
    </Link>
  )
}

export default Logo;
